import { render, staticRenderFns } from "./LicenseApplication.vue?vue&type=template&id=015317ba&"
import script from "./LicenseApplication.vue?vue&type=script&lang=js&"
export * from "./LicenseApplication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports